import { render, staticRenderFns } from "./FlipCard.vue?vue&type=template&id=4caa67dd&scoped=true&"
import script from "./FlipCard.vue?vue&type=script&lang=js&"
export * from "./FlipCard.vue?vue&type=script&lang=js&"
import style0 from "./FlipCard.vue?vue&type=style&index=0&id=4caa67dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caa67dd",
  null
  
)

export default component.exports